
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33.094","height":"17.582"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#3e3e3e"}},[_c('path',{attrs:{"d":"M13.89 14.925a2.657 2.657 0 105.314 0c0-1.109-1.52-5.263-2.261-7.221a.423.423 0 00-.792 0c-.74 1.958-2.261 6.112-2.261 7.221zM3.789 11.152l-1.912-1.151a.431.431 0 00-.618.2A16.476 16.476 0 000 16.116a.432.432 0 00.432.438h1.887a.419.419 0 00.416-.39 12.535 12.535 0 011.211-4.467.418.418 0 00-.157-.545zM8.802 5.852l-1.7-2.356a.43.43 0 00-.607-.093 16.626 16.626 0 00-3.908 4.252.432.432 0 00.143.6l2.1 1.266a.418.418 0 00.546-.105 12.711 12.711 0 013.3-2.959.419.419 0 00.126-.605zM15.334 4.552q.434 0 .861.03c.135.009.452-.313.452-.313l.5-3.778-.417-.49a16.473 16.473 0 00-7.813 1.858.431.431 0 00-.145.631l1.9 2.636a.414.414 0 00.478.147 12.582 12.582 0 014.184-.721zM24.173 7.639l3.156-3.02a.431.431 0 00-.012-.635 16.517 16.517 0 00-7.729-3.7.432.432 0 00-.5.368l-.529 3.962a.417.417 0 00.3.456 12.623 12.623 0 014.747 2.583.417.417 0 00.567-.014zM28.348 16.552h4.314a.432.432 0 00.432-.438A16.492 16.492 0 0029.325 6.03a.433.433 0 00-.628-.033l-3.2 3.064a.418.418 0 00-.042.556 12.584 12.584 0 012.481 6.545.419.419 0 00.412.39z"}})])])
          )
        }
      }
    